import { render, staticRenderFns } from "./GoodsItem.vue?vue&type=template&id=07f07724&"
import script from "./GoodsItem.vue?vue&type=script&lang=js&"
export * from "./GoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./GoodsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports